import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SpecialtyDropdown from "../shared//SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";

const SearchOrg = () => {
  const {
    userRole,
    userToken,
    customerObj,
    setSearchObj,
    sharedObject,
    SetSharedObject,
    userSession,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    customerObj: state.customerObj,
    setSearchObj: state.setSearchObj,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
  }));
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState(null);
  const [orgValues, SetOrgValues] = useState([]);
  const [custObject, SetCustObject] = useState([]);
  const [orgObject, SetOrgObject] = useState([]);
  const [loadingText, setLoadingText] = useState("Loading...");

  const statusRef = useRef(null);
  const previousFocusRef = useRef(null);
  const firstFocusRef = useRef(null);

  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };

  useEffect(() => {
    const getOrgVals = async (val) => {
      SetOrgValues(sharedObject.getOrgKinds);
      let temp = [];
      if (sharedObject.vendorsObj) {
        for (let el of sharedObject.vendorsObj) {
          if (el.name === customerObj.Name) {
            let vl = el.baseDomainId + "-" + el.id;
            //getVendorsDomains(vl);
            setAnswer("VendorVal", vl);
          }
          el.show = true;
          temp.push(el);
        }
        SetCustObject(temp);
      }
    };
    SetOrgValues(sharedObject.getOrgKinds);
    SetOrgObject([]);
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
    ) {
      getOrgVals("top");
    } else {
      getOrgVals("sub");
    }
  }, []);

  useEffect(() => {
    const modalEl = document.getElementById("advOrgSearchModal");
    if (!modalEl) return;

    const onShown = () => {
      previousFocusRef.current = document.activeElement;
      setTimeout(() => firstFocusRef.current?.focus(), 50);
    };
    const onHidden = () => {
      previousFocusRef.current?.focus();
    };

    modalEl.addEventListener("shown.bs.modal", onShown);
    modalEl.addEventListener("hidden.bs.modal", onHidden);
    return () => {
      modalEl.removeEventListener("shown.bs.modal", onShown);
      modalEl.removeEventListener("hidden.bs.modal", onHidden);
    };
  }, []);

  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      SpecialtyType: val.SpecialtyType,
      SpecialtySpecialization: val.SpecialtyClassification,
      SpecializationCode: val.SpecialtySpecialization,
    });
  };
  
  const getVendorsDomains = async (val) => {
    let domId = val.split("-");
    setAnswer("OrganizationId", "");
    SetProcessing(true);
    let obj = { VendorId: domId[1] };
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let temp = [];
      if (res.data.data) {
        for (let el of res.data.data) {
          el.show = true;
          temp.push(el);
        }
      }
      SetOrgObject(temp);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObject(tmp);
  };
  const SubmitSearch = async (event) => {
    event.preventDefault();
    console.log(answers);
    var vendor;
    var ob;
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
    ) {
      vendor = answers.VendorVal.split("-");
      ob = { ...answers, VendorId: vendor[1] };
    } else {
      vendor = userSession.vendor_id;
      ob = { ...answers, VendorId: vendor };
    }
    SetProcessing(true);
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, ob, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setSearchObj(res.data.data);
      CloseAdvSearch();
      if (statusRef.current)
        statusRef.current.textContent = "Search completed successfully.";
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
      if (statusRef.current)
        statusRef.current.textContent = "Search failed. Please try again.";
    }
    SetProcessing(false);
  };

  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseAdvSearch = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
    $('#advOrgSearchModal').modal('hide');
};

 //  Focus trap � excludes disabled elements, same pattern as XdrSetting
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      CloseAdvSearch();
      return;
    }
    if (e.key !== "Tab") return;

    const modal = e.currentTarget;
    const focusable = modal.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };
  return (
    <div className="SearchOrg">
    <div
        ref={statusRef}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      />
      <div
        className="modal fade"
        id="advOrgSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="advanced-org-search-title"
        aria-describedby="advancedOrgSearchDesc"
        data-backdrop="static"
        aria-modal="true"
        onKeyDown={handleKeyDown}
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title spacer-inline" id="advanced-org-search-title">
                Advanced Search
              </h2>
                <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={CloseAdvSearch}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form onSubmit={(event) => SubmitSearch(event)}>
              <div className="modal-body">
                <div className="modal-content-body container" id="advancedOrgSearchDesc">
                  {userRole === "SES ADMINISTRATOR" ||
                  userRole === "SYSTEMADMINISTRATOR" ? (
                    <div>
                      <div className="field-wrapper">
                        <label htmlFor="CustomerName" className="sp-margin3">
                          Customer
                        </label>
                        <span className="filter-container dg-clr">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter Customers"
                            aria-controls="CustomerName"
                            onChange={(el) => filterVendors(el.target.value)}
                          />
                        </span>
                        <select
                          className="form-control"
                          id="CustomerName"
                          name="CustomerName"
                          value={answers?.VendorVal}
                          size="4"
                          ref={firstFocusRef}
                          onChange={(el) => {
                            getVendorsDomains(el.target.value);
                            setAnswer("VendorVal", el.target.value);
                          }}
                        >
                          <option value="">Select Customer</option>
                          {custObject?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.id}
                                  value={el.baseDomainId + "-" + el.id}
                                >
                                  {el.name}
                                </option>
                              );
                          })}
                        </select>
                      </div>

                      <div className="field-wrapper">
                        <label htmlFor="OrganizationId" className="sp-margin3">
                          Organization
                        </label>
                        <span className="filter-container dg-clr">
                        <label htmlFor="org-filter" className="sr-only">
                            Filter organizations
                          </label>
                          <input
                            className="form-control filter-sm"
                            type="search"
                            id="org-filter"
                            aria-controls="OrganizationId"
                            placeholder="Filter"
                            onChange={(el) =>
                              filterOrganiations(el.target.value)
                            }
                          />
                        </span>

                        {orgObject.length === 0 ? (
                          <div className="watermark-wrapper" role="status" aria-live="polite">No Results</div>
                        ) : (
                          <select
                            className="form-control"
                            size="4"
                            id="OrganizationId"
                            name="OrganizationId"
                            value={answers?.OrganizationId}
                            onChange={(el) =>
                              setAnswer("OrganizationId", el.target.value)
                            }
                          >
                            <option value="">Select Organization</option>
                            {orgObject?.map((el) => {
                              if (el.show)
                                return (
                                  <option key={el.id} value={el.id}>
                                    {el.name}
                                  </option>
                                );
                            })}
                          </select>
                        )}
                      </div>
                    </div>
                  ) : null}
                  {userRole === "ADMINISTRATOR" ? (
                    <div className="field-wrapper">
                      <label htmlFor="OrganizationName">Organization Name</label>
                      <input
                        type="text"
                        id="OrganizationName"
                        className="form-control"
                        autoComplete="organization"
                        value={answers?.OrganizationName}
                        onChange={(el) =>
                          setAnswer("OrganizationName", el.target.value)
                        }
                      />
                    </div>
                  ) : null}
                  {/*Org Type*/}
                  <div className="field-wrapper">
                    <label htmlFor="OrgType">Organization Type</label>
                    <select
                      className="form-control"
                      id="OrgType"
                      name="OrganizationKind"
                      value={answers?.OrganizationKind}
                      onChange={(el) =>
                        setAnswer("OrganizationKind", parseInt(el.target.value))
                      }
                    >
                      <option value="">Select</option>
                      {orgValues?.map((el) => (
                        <option key={el.id} value={el.id}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*City*/}
                  <div className="field-wrapper">
                    <label htmlFor="City">City</label>
                    <input
                      type="text"
                      className="form-control"
                      id="City"
                      autoComplete="address-level2"
                      value={answers?.City}
                      onChange={(el) => setAnswer("City", el.target.value)}
                    />
                  </div>
                  {/*State and Zip*/}
                  <div className="field-wrapper">
                    <div className="field-box1 field-ext">
                      <label htmlFor="search-org-state">State</label>
                      <select
                        className="form-control"
                        name="State"
                        id="search-org-state"
                        value={answers?.State}
                        onChange={(el) => setAnswer("State", el.target.value)}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="field-box1 field-ext">
                      <label htmlFor="Zip">Zip</label>
                      <input
                        className="form-control"
                        name="Zip"
                        id="Zip"
                        autoComplete="postal-code"
                        value={answers?.Zip}
                        onChange={(el) => setAnswer("Zip", el.target.value)}
                      />
                    </div>
                  </div>

                  <div className=" field-wrapper">
                    <div id="accordion" className="accordion">
                      <div className="card mb-0">
                        <div
                          className="card-header collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapseThree"
                        ></div>
                        <div
                          id="collapseThree"
                          className="collapse"
                          data-parent="#accordion"
                          role="region"
                          aria-labelledby="specialty-heading"
                        >
                          <div className="field-wrapper spacer-margin4">
                            <div className="ctr sub-titles spacer-margin7 blk-clr" id="specialty-heading">
                              Specialty
                            </div>
                            <p className="text-reg spacer-margin7">
                              All three criteria must be selected to search by
                              Specialty.
                            </p>
                            {/*Specialty Component*/}
                            <SpecialtyDropdown
                              SpecialFormFields={SpecialFormFields}
                              codes={orgValues?.codes}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-success" disabled={processing}>
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseAdvSearch}
                  disabled={processing}
                >
                  Cancel
                </button>
              </div>
              {processing && (
                <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="loader-id"
                >
                    <div className="spinner" aria-hidden="true"></div>
                    <div className="loading-text" id="loader-id">{loadingText}</div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchOrg;
